import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
const Login = () => {
  return <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC] py-12 px-4 sm:px-6 lg:px-8" data-id="element-1027">
      <div className="max-w-md w-full space-y-8" data-id="element-1028">
        <div className="text-center" data-id="element-1029">
          <h1 className="font-display text-3xl font-bold text-gray-900" data-id="element-1030">
            Welcome back
          </h1>
          <p className="mt-2 text-gray-600" data-id="element-1031">
            Sign in to your account to continue
          </p>
        </div>
        <div className="bg-white p-8 rounded-xl shadow-sm" data-id="element-1032">
          <form className="space-y-6" data-id="element-1033">
            <div data-id="element-1034">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1035">
                Email address
              </label>
              <input id="email" name="email" type="email" autoComplete="email" required className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-transparent transition-all" placeholder="you@example.com" data-id="element-1036" />
            </div>
            <div data-id="element-1037">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2" data-id="element-1038">
                Password
              </label>
              <input id="password" name="password" type="password" autoComplete="current-password" required className="w-full px-4 py-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-[#d73b3e] focus:border-transparent transition-all" data-id="element-1039" />
            </div>
            <div className="flex items-center justify-between" data-id="element-1040">
              <div className="flex items-center" data-id="element-1041">
                <input id="remember_me" name="remember_me" type="checkbox" className="h-4 w-4 text-[#d73b3e] focus:ring-[#d73b3e] border-gray-300 rounded" data-id="element-1042" />
                <label htmlFor="remember_me" className="ml-2 block text-sm text-gray-700" data-id="element-1043">
                  Remember me
                </label>
              </div>
              <div className="text-sm" data-id="element-1044">
                <a href="#" className="font-medium text-[#d73b3e] hover:text-[#c02f32] transition-colors" data-id="element-1045">
                  Forgot your password?
                </a>
              </div>
            </div>
            <div data-id="element-1046">
              <button type="submit" className="w-full px-6 py-3 bg-[#d73b3e] text-white rounded-full font-semibold hover:bg-[#c02f32] transition-all duration-200 shadow-sm" data-id="element-1047">
                Sign in
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1048">
            <div className="relative" data-id="element-1049">
              <div className="absolute inset-0 flex items-center" data-id="element-1050">
                <div className="w-full border-t border-gray-300" data-id="element-1051" />
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1052">
                <span className="px-2 bg-white text-gray-500" data-id="element-1053">
                  Or continue with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1054">
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1055">
                <span className="sr-only" data-id="element-1056">Sign in with GitHub</span>
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1057">
                  <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1058" />
                </svg>
              </a>
              <a href="#" className="w-full inline-flex justify-center py-3 px-4 border border-gray-300 rounded-xl shadow-sm bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 transition-colors" data-id="element-1059">
                <span className="sr-only" data-id="element-1060">Sign in with Google</span>
                <svg className="w-5 h-5" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" data-id="element-1061">
                  <path d="M12.48 10.92v3.28h7.84c-.24 1.84-.853 3.187-1.787 4.133-1.147 1.147-2.933 2.4-6.053 2.4-4.827 0-8.6-3.893-8.6-8.72s3.773-8.72 8.6-8.72c2.6 0 4.507 1.027 5.907 2.347l2.307-2.307C18.747 1.44 16.133 0 12.48 0 5.867 0 .307 5.387.307 12s5.56 12 12.173 12c3.573 0 6.267-1.173 8.373-3.36 2.16-2.16 2.84-5.213 2.84-7.667 0-.76-.053-1.467-.173-2.053H12.48z" data-id="element-1062" />
                </svg>
              </a>
            </div>
          </div>
        </div>
        <div className="text-center" data-id="element-1063">
          <p className="text-sm text-gray-600" data-id="element-1064">
            Don't have an account?{' '}
            <Link to="/signup" className="font-medium text-[#d73b3e] hover:text-[#c02f32] transition-colors" data-id="element-1065">
              Sign up
            </Link>
          </p>
        </div>
      </div>
    </div>;
};
export default Login;